import { render, staticRenderFns } from "./form-clearbalance.vue?vue&type=template&id=04529495&scoped=true&"
import script from "./form-clearbalance.vue?vue&type=script&lang=js&"
export * from "./form-clearbalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04529495",
  null
  
)

export default component.exports